import {CircleCheck, GraduationCap} from "lucide-react";
import {Trans} from "react-i18next";
import {useTranslationWithKeys} from "../../hooks/useTranslationWithKeys";
import {NotificationBanner} from "./banners/NotificationBanner";

interface AlumniActivatedBannerProps {
    email: string;
    onClose: () => void;
}

/**
 * Confirmation shown once after the alumni conversion, in the
 * {@link HeroBannerSlot} where the alumni offer used to be.
 */
export function AlumniActivatedBanner({email, onClose}: AlumniActivatedBannerProps) {
    const {t} = useTranslationWithKeys();

    return (
        <NotificationBanner
            variant="promo"
            prominence="hero"
            icon={<CircleCheck/>}
            decoration={
                <GraduationCap
                    aria-hidden="true"
                    className="pointer-events-none absolute -top-8 -right-8 hidden h-56 w-56 rotate-12 opacity-10 lg:block"
                />
            }
            message={t('alumni.activated.title')}
            description={
                <Trans
                    i18nKey="alumni.activated.description"
                    values={{email}}
                    components={{strong: <strong className="font-semibold"/>}}
                />
            }
            onClose={onClose}
        />
    );
}
